import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { RouterView } from 'vue-router'

import '@sennder/design-system-core/dist/styles/themes/default.css'
import '@sennder/design-system-core'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_dsf_text = _resolveComponent("dsf-text")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_dsf_text, null, {
      default: _withCtx(() => [
        _createTextVNode(" This is your shell, now you are able to connect µFs to your application ")
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_unref(RouterView))
  ]))
}
}

})